const getters = {
	addressInfo: (state) => state.mapData.addressInfo,
	allData: (state) => state.mapData.allData,
};
export default getters;
